import { Outlet, Route, Routes } from 'react-router-dom'
import { Error500 } from './components/Error500'
import { Error404 } from './components/Error404'
import { useEffect } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import './styles.scss';

const ErrorsLayout = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `none`
    return () => {
      document.body.style.backgroundImage = `url(${toAbsoluteUrl('/media/patterns/header-bg.jpg')})`
    }
  }, [])

  return <Outlet />
}

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path='404' element={<Error404
        strings={["متاسفانه صفحه مورد نظر یافت نشد!"]}
        typeSpeed={100}
        backSpeed={50}
        backDelay={1000}
        loop={true}
        showCursor={true}
        cursorChar="|"
      />} />
      <Route path='500' element={<Error500 />} />
      <Route index element={<Error404
        strings={["متاسفانه صفحه مورد نظر یافت نشد!"]}
        typeSpeed={100}
        backSpeed={50}
        backDelay={1000}
        loop={true}
        showCursor={true}
        cursorChar="|"
      />} />
    </Route>
  </Routes>
)

export { ErrorsPage }
